
const digest = 'c836bea5f39574c691905648498dda43332769fab458e928711b57c5fadc47cf';
const classes = {"wrapper":"_wrapper_lue9b_1","historyWrapper":"_historyWrapper_lue9b_32","title":"_title_lue9b_42"};
const css = `._wrapper_lue9b_1 {
  font-family: Rubik, "sans-serif";
  border: 1px solid #eaedf3;
  border-top: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  background: #ffffff;
}
._wrapper_lue9b_1::-webkit-scrollbar {
  display: block;
}
._wrapper_lue9b_1::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_lue9b_1::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_lue9b_1::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_lue9b_1::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_lue9b_1 ._historyWrapper_lue9b_32 {
  border-top: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 32px 24px 0 24px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  min-height: 500px;
}
._wrapper_lue9b_1 ._historyWrapper_lue9b_32 ._title_lue9b_42 {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  